import { createPaginationContainer, graphql } from 'react-relay';
import InvoiceList from './InvoiceList';
import InvoiceQuery from '../../../routes/InvoiceQuery';

export default createPaginationContainer(
  InvoiceList,
  {
    viewer: graphql`
      fragment InvoiceListContainer_viewer on User
        @argumentDefinitions(
          status: { type: "InvoiceStatus" }
          count: { type: "Int" }
          cursor: { type: "String" }
        ) {
        invoices (
          status: $status
          first: $count
          after: $cursor
        ) @connection(key: "InvoiceList_invoices") {
          edges {
            node {
              id
              title
              status
              total_cents
              outstanding_cents
              workspaces(first: 1) {
                edges {
                  node {
                    event {
                      id
                      title
                    }
                  }
                }
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }`
  },
  {
    direction: 'forward',
    getConnectionFromProps(props) {
      return props.viewer && props.viewer.invoices;
    },
    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount
      };
    },
    getVariables(props, { count, cursor }, fragmentVariables) {
      return {
        count,
        cursor,
        status: fragmentVariables.status
      };
    },
    query: InvoiceQuery
  }
);



// WEBPACK FOOTER //
// ./webpack/components/Financial/Invoices/InvoiceListContainer.js